import { message, Modal } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { isMobile } from '@/extensions/design';

const TakePhoto = ({ onClose, onSave }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [connected, setConnected] = useState(false);

  const startCamera = () => {
    const videoConstraints = isMobile
      ? { facingMode: { ideal: "environment" } }
      : true;
  
    navigator.mediaDevices.getUserMedia({ video: videoConstraints })
      .then(stream => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
        setConnected(true);
      })
      .catch(e => {
        message.error("Ошибка подключения камеры");
        console.error(e);
      });
  };
  

  useEffect(() => {
    startCamera();
  
    return () => {
      const stream = videoRef.current?.srcObject;
      stream?.getTracks().forEach(track => track.stop());
    };
  }, [isMobile]);
  

  const onSaveBtn = (event) => {
    event.preventDefault();
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(imageFile => {
      if (imageFile) {
        onSave(imageFile);
        onClose(true);
      }
    });
  }

  const formStyles = {
    content: { padding: 8 },
    footer: { marginTop: 0 },
  };

  return (
    <Modal width={400} open closeIcon={null} disabled={!connected} onCancel={() => onClose()} onOk={onSaveBtn} styles={formStyles}>
      <video ref={videoRef} autoPlay style={{ width: '100%', height: 'auto' }}></video>
      <canvas ref={canvasRef} style={{ display: 'none' }} width={640} height={480} />
    </Modal>
  );
}

export default TakePhoto;